import React from "react";
import { toPersianNum } from "../../assets/utils";
import { socketServer } from "../../assets/socketConnection";
import {
  Ticket,
  DateContainer,
  Status,
  Date,
  CategoryContainer,
  AudioPlayer,
} from "./tickets.styles";
const Tickets = ({ ticket }) => {
  console.log("v", `${socketServer}uploaded_voices/${ticket.voice}.m4a`);
  return (
    <Ticket>
      <DateContainer>
        <Status status={ticket.status}>{ticket.status_persian}</Status>
        <Date>{toPersianNum(ticket.date_persian)}</Date>
      </DateContainer>
      <CategoryContainer>
        <Date>دسته بندی : </Date>
        {ticket.category}
      </CategoryContainer>
      <CategoryContainer>
        <Date>عنوان : </Date>
        {ticket.title}
      </CategoryContainer>
      <div>{ticket.content}</div>
      {ticket.voice && <AudioPlayer src={`${socketServer}uploaded_voices/${ticket.voice}.m4a`} controls />}
    </Ticket>
  );
};

export default Tickets;
